'use strict';

angular.module('mandaeApp')
  .factory('FinalizaCadastro', function($rootScope, $state, $q, $timeout, localStorageService, ClienteResource) {

    var user = localStorageService.get('user');

    return {

      gravaDocumentos: function(documentos, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();
        // atualiza user no LS
        var user = localStorageService.get('user');
        user.gastoMensalComFrete = documentos.gastoMensal;

        localStorageService.set('user', user);

        ClienteResource.gravarDocumentos({ idCliente: user.id }, documentos).$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          }).
        catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

        return deferred.promise;
      },
      gravaGastoMensal: function(cliente, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();
        // atualiza user no LS
        var user = localStorageService.get('user');
        user.gastoMensalComFrete = cliente.gastoMensal;

        localStorageService.set('user', user);

        ClienteResource.gravarGastoMensal({ idCliente: user.id }, cliente).$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          }).
        catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

        return deferred.promise;
      },
       gravarDadosContato: function(cliente, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.gravarDadosContato({ idCliente: user.id }, cliente).$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          }).
        catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

        return deferred.promise;
      }
    };
  });
